<template>
  <span :class="$style.chip">反社</span>
</template>

<style lang="scss" module>
.chip {
  border-radius: 100vmax;
  padding: 6px 12px 8px;
  background-color: $color-surface-quinary;
  color: $color-text-and-object-accent-red;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}
</style>
